import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { find, get, isEmpty } from "lodash";
import {
  ManagePlanLayout,
  AddPlans,
  CsplTable as Table,
  LoaderWrapper,
} from "../../../components";
import {
  FLOW_TYPES,
  MANAGE_PLAN_ROUTES,
  getPathWithParam,
  getAdvancedPathWithParam,
  OPTIONS_DATA_MAPPER,
  toMultiSelectValueById,
  tranformListToDropdownValues,
} from "../../../utils";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import { clearLocalCacheByModel, createPlanStore } from "../../../contexts";
import AddToolTip from "../../../components/AddToolTip";
import { getManageEligibleRule } from "../../../services";
import moment from "moment";

const columns = [
  {
    label: "Eligibility Name",
    className: "column-eligibilityName",
    columnName: "name",
    link: `${MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY}`,
  },
  {
    label: "Eligibility For",
    className: "column-eligibilityFor",
    columnName: "eligibilityRuleFor",
    dataMapper: OPTIONS_DATA_MAPPER.ELIGIBILITY_TYPE,
  },
];
const eligibilityRuleCard = [
  {
    id: 1,
    eligibilityRuleFor: 1,
    eligibilityType: 2,
    name: "Eligibility One",
    effectiveFrom: "01/01/2023",
    effectiveTo: "-",
    planAmmendments: [
      {
        eligibilityRuleFor: 1,
        eligibilityType: 1,
        effectiveFrom: "01/01/2023",
        effectiveTo: "-",
      },
    ],
  },
  {
    id: 2,
    eligibilityRuleFor: 1,
    eligibilityType: 1,
    name: "Eligibility Two",
    effectiveFrom: "01/01/2023",
    effectiveTo: "-",
    planAmmendments: [],
  },
  {
    id: 3,
    eligibilityRuleFor: 1,
    eligibilityType: 2,
    name: "Eligibility Three",
    effectiveFrom: "01/01/2023",
    effectiveTo: "-",
    planAmmendments: [
      {
        eligibilityRuleFor: 1,
        eligibilityType: 2,
        effectiveFrom: "01/01/2023",
        effectiveTo: "-",
      },
      {
        eligibilityRuleFor: 1,
        eligibilityType: 1,
        effectiveFrom: "01/01/2023",
        effectiveTo: "-",
      },
    ],
  },
  {
    id: 4,
    eligibilityRuleFor: 1,
    eligibilityType: 3,
    name: "Eligibility Four",
    effectiveFrom: "01/01/2023",
    effectiveTo: "-",
    planAmmendments: null,
  },
];

const Eligibility = (props) => {
  const { flow, planId } = useRouterParams();
  const { state, dispatch } = useContext(createPlanStore);
  const planData = get(state, "api.reviewAndPlanDetail", {});

  const { response: Eligible, loading: load } = useRequest({
    method: getManageEligibleRule,
    payload: planId,
    defaultResponse: [],
  });
  const eligibilityRules = Eligible?.eligibilityRules;
  const eligiblityList =
    eligibilityRules &&
    Object.keys(eligibilityRules).map((x, i) =>
      eligibilityRules[x].map((y, o) => y)
    );
  const eligiblity = eligiblityList && eligiblityList;

  useEffect(() => {
    dispatch(clearLocalCacheByModel("eligibilityRules"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { history } = props;

  const onAddClick = () => {
    history.push(
      getAdvancedPathWithParam({
        path: MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY,
        pathParam: [planId, 0, 0],
      })
    );
  };

  const buttons = [
    {
      label: "Add",
      variant: "primary",
      type: "button",
      flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
      onClick: onAddClick,
    },
    // {
    //   label: "",
    //   variant: "secondary",
    //   type: "button",
    //   flow: [FLOW_TYPES.ADD, FLOW_TYPES.EDIT, FLOW_TYPES.SAVE],
    //   isAddButton: true,
    //   onClick: onAddClick,
    // },
  ];
  const getEligibilityType = (type) => {
    switch (type) {
      case 1:
        return "Age";
      case 2:
        return "Service";
      case 3:
        return "Age and Service";
      default:
        return "Immediate";
    }
  };
  return (
    <ManagePlanLayout buttons={buttons} pageFlow={flow}>
      <LoaderWrapper isLoading={load}>
        {isEmpty(eligibilityRules) && (
          <AddPlans
            menu="plan"
            subMenu="eligibility"
            content="No eligibility rules."
            buttonLabel="Add Eligibility Rule"
            link={getAdvancedPathWithParam({
              path: MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY,
              pathParam: [FLOW_TYPES.SAVE, planId, 0, 0, 0],
            })}
          />
        )}
        {!isEmpty(eligibilityRules) && (
          <div className="w-100">
            <div className="d-flex w-100 align-items-center justify-content-between mb-4">
              <div className="m-0 plan-heading font-weight-500">
                Manage Eligibility
              </div>
            </div>

            {Object.keys(eligibilityRules).map((data, i) => (
              <div className="margbot-20">
                {eligiblity[i].map((x, index) => (
                  <div>
                    {index == 0 ? (
                      x.directAmendment == 0 ? (
                        <div
                          className="eligiblityCard"
                          onClick={() =>
                            history.push(
                              getAdvancedPathWithParam({
                                path: `${MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY}`,
                                pathParam: [
                                  FLOW_TYPES.EDIT,
                                  planId,
                                  x.id,
                                  x.planAmendmentId,
                                  0,
                                ],
                              })
                            )
                          }
                        >
                          <div className="disp-flex-row justify-content-between pad-25-50-25-50">
                            <div>
                              <p className="card-title fw-400 ft-14 margbot-5">
                                Eligibility Name
                              </p>

                              {x?.name?.length >= 10 ? (
                                <AddToolTip name={x.name} placement="bottom">
                                  <p className="ft-16 fw-400">
                                    {(x.name || "").slice(0, 10)}...
                                  </p>
                                </AddToolTip>
                              ) : (
                                <p className="ft-16 fw-400">{x.name}</p>
                              )}
                            </div>
                            <div>
                              <p className="card-title fw-400 ft-14 margbot-5">
                                Rule Type
                              </p>
                              <p className="card-value ft-14 fw-400">
                                {getEligibilityType(x.eligibilityType)}
                              </p>
                            </div>
                            <div>
                              <p className="card-title fw-400 ft-14 margbot-5">
                                Applicable To
                              </p>

                              {get(planData, "planName", "")?.length >= 10 ||
                              x?.sourceName?.length >= 10 ? (
                                <AddToolTip
                                  name={
                                    x.eligibilityRuleFor == 1
                                      ? get(planData, "planName", "")
                                      : x.sourceName
                                  }
                                  placement="bottom"
                                >
                                  <p className="card-value ft-14 fw-400">
                                    {x.eligibilityRuleFor == 1
                                      ? `Plan-${(
                                          get(planData, "planName", "") || ""
                                        ).slice(0, 10)}...`
                                      : `Source-${(x.sourceName || "").slice(
                                          0,
                                          10
                                        )}...`}
                                  </p>
                                </AddToolTip>
                              ) : (
                                <p className="card-value ft-14 fw-400">
                                  {x.eligibilityRuleFor == 1
                                    ? `Plan-${get(planData, "planName", "")}`
                                    : `Source-${x.sourceName}`}
                                </p>
                              )}
                            </div>
                            <div>
                              <p className="card-title fw-400 ft-14 margbot-5">
                                Effective From
                              </p>
                              <p className="card-value ft-14 fw-400">
                                {moment(new Date(x.effectiveFrom)).format(
                                  "MM/DD/YYYY"
                                )}
                              </p>
                            </div>
                            <div>
                              <p className="card-title fw-400 ft-14 margbot-5">
                                Effective To
                              </p>
                              <p className="card-value ft-14 fw-400">
                                {x.effectiveTo
                                  ? moment(new Date(x.effectiveTo)).format(
                                      "MM/DD/YYYY"
                                    )
                                  : "-"}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="directAmmendmentCard"
                          onClick={() =>
                            history.push(
                              getAdvancedPathWithParam({
                                path: `${MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY}`,
                                pathParam: [
                                  FLOW_TYPES.EDIT,
                                  planId,
                                  x.id,
                                  x.planAmendmentId,
                                  1,
                                ],
                              })
                            )
                          }
                        >
                          <div className="disp-flex-row justify-content-between">
                            <div>
                              <div
                                className="ft-12 fw-500"
                                style={{
                                  backgroundColor: "#F19937",
                                  width: "fit-content",
                                  color: "white",
                                  borderRadius: "5px 0px 5px 0px",
                                  padding: "5px 8px 5px 8px",
                                }}
                              >
                                Amendment
                              </div>
                              {x?.planAmendmentDescription?.length >= 10 ? (
                                <AddToolTip
                                  name={x.planAmendmentDescription}
                                  placement="bottom"
                                >
                                  <p
                                    className="ft-16 fw-400"
                                    style={{
                                      paddingLeft: "40px",
                                      paddingTop: "10px",
                                    }}
                                  >
                                    {(x.planAmendmentDescription || "").slice(
                                      0,
                                      10
                                    )}
                                    ...
                                  </p>
                                </AddToolTip>
                              ) : (
                                <p
                                  className="ft-16 fw-400"
                                  style={{
                                    paddingLeft: "40px",
                                    paddingTop: "10px",
                                  }}
                                >
                                  {x.planAmendmentDescription}
                                </p>
                              )}
                            </div>
                            <div style={{ paddingTop: "16px" }}>
                              <p className="card-title fw-400 ft-14 margbot-5">
                                Applicable To
                              </p>
                              {get(planData, "planName", "").length >= 10 ||
                              x?.sourceName?.length >= 10 ? (
                                <AddToolTip
                                  name={
                                    x.eligibilityRuleFor == 1
                                      ? get(planData, "planName", "")
                                      : x.sourceName
                                  }
                                  placement="bottom"
                                >
                                  <p className="card-value ft-14 fw-400">
                                    {x.eligibilityRuleFor == 1
                                      ? `Plan-${(
                                          get(planData, "planName", "") || ""
                                        ).slice(0, 10)}`
                                      : `Source-${(x.sourceName || "").slice(
                                          0,
                                          10
                                        )}`}
                                  </p>
                                </AddToolTip>
                              ) : (
                                <p className="card-value ft-14 fw-400">
                                  {x.eligibilityRuleFor == 1
                                    ? `Plan-${get(planData, "planName", "")}`
                                    : `Source-${x.sourceName}`}
                                </p>
                              )}
                            </div>
                            <div style={{ paddingTop: "16px" }}>
                              <p className="card-title fw-400 ft-14 margbot-5">
                                Rule Type
                              </p>
                              <p className="card-value ft-14 fw-400">
                                {getEligibilityType(x.eligibilityType)}
                              </p>
                            </div>
                            <div style={{ paddingTop: "16px" }}>
                              <p className="card-title fw-400 ft-14 margbot-5">
                                Effective From
                              </p>
                              <p className="card-value ft-14 fw-400">
                                {moment(new Date(x.effectiveFrom)).format(
                                  "MM/DD/YYYY"
                                )}
                              </p>
                            </div>
                            <div style={{ padding: "16px 50px 0px 0px" }}>
                              <p className="card-title fw-400 ft-14 margbot-5">
                                Effective To
                              </p>
                              <p className="card-value ft-14 fw-400">
                                {x.effectiveTo
                                  ? moment(new Date(x.effectiveTo)).format(
                                      "MM/DD/YYYY"
                                    )
                                  : "-"}
                              </p>
                            </div>
                          </div>
                        </div>
                      )
                    ) : (
                      // <div className={data.planAmmendments.length - 1 == i ? "ammendmentCard " : "ammendmentCard border-bot-none"} >
                      <div
                        className={
                          eligiblity[i]?.length - 1 == index
                            ? "ammendmentCard "
                            : "ammendmentCard border-bot-none"
                        }
                        onClick={() =>
                          history.push(
                            getAdvancedPathWithParam({
                              path: `${MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY}`,
                              pathParam: [
                                FLOW_TYPES.EDIT,
                                planId,
                                x.id,
                                x.planAmendmentId,
                                1,
                              ],
                            })
                          )
                        }
                      >
                        <div
                          className="ammendmentSubCard"
                          onClick={() =>
                            history.push(
                              getAdvancedPathWithParam({
                                path: `${MANAGE_PLAN_ROUTES.ADD_ELIGIBILITY}`,
                                pathParam: [FLOW_TYPES.SAVE, planId, index, 1],
                              })
                            )
                          }
                        >
                          <div className="disp-flex-row justify-content-between">
                            <div>
                              <div
                                className="ft-12 fw-500"
                                style={{
                                  backgroundColor: "#F19937",
                                  width: "fit-content",
                                  color: "white",
                                  borderRadius: "5px 0px 5px 0px",
                                  padding: "5px 8px 5px 8px",
                                }}
                              >
                                Amendment
                              </div>
                              {x?.planAmendmentDescription?.length >= 10 ? (
                                <AddToolTip
                                  name={x.planAmendmentDescription}
                                  placement="bottom"
                                >
                                  <p
                                    className="ft-16 fw-400"
                                    style={{
                                      paddingLeft: "40px",
                                      paddingTop: "10px",
                                    }}
                                  >
                                    {(x.planAmendmentDescription || "").slice(
                                      0,
                                      10
                                    )}
                                    ...
                                  </p>
                                </AddToolTip>
                              ) : (
                                <p
                                  className="ft-16 fw-400"
                                  style={{
                                    paddingLeft: "40px",
                                    paddingTop: "10px",
                                  }}
                                >
                                  {x.planAmendmentDescription}
                                </p>
                              )}
                            </div>
                            <div style={{ paddingTop: "16px" }}>
                              <p className="card-title fw-400 ft-14 margbot-5">
                                Applicable To
                              </p>
                              {get(planData, "planName", "").length >= 20 ||
                              x?.sourceName?.length >= 20 ? (
                                <AddToolTip
                                  name={
                                    x.eligibilityRuleFor == 1
                                      ? get(planData, "planName", "")
                                      : x.sourceName
                                  }
                                  placement="bottom"
                                >
                                  <p className="card-value ft-14 fw-400">
                                    {x.eligibilityRuleFor == 1
                                      ? `Plan-${(
                                          get(planData, "planName", "") || ""
                                        ).slice(0, 20)}...`
                                      : `Source-${(x.sourceName || "").slice(
                                          0,
                                          10
                                        )}...`}
                                  </p>
                                </AddToolTip>
                              ) : (
                                <p className="card-value ft-14 fw-400">
                                  {x.eligibilityRuleFor == 1
                                    ? `Plan-${get(planData, "planName", "")}`
                                    : `Source-${x.sourceName}`}
                                </p>
                              )}
                            </div>
                            <div style={{ paddingTop: "16px" }}>
                              <p className="card-title fw-400 ft-14 margbot-5">
                                Rule Type
                              </p>
                              <p className="card-value ft-14 fw-400">
                                {getEligibilityType(x.eligibilityType)}
                              </p>
                            </div>
                            <div style={{ paddingTop: "16px" }}>
                              <p className="card-title fw-400 ft-14 margbot-5">
                                Effective From
                              </p>
                              <p className="card-value ft-14 fw-400">
                                {moment(new Date(x.effectiveFrom)).format(
                                  "MM/DD/YYYY"
                                )}
                              </p>
                            </div>
                            <div style={{ padding: "16px 50px 0px 0px" }}>
                              <p className="card-title fw-400 ft-14 margbot-5">
                                Effective To
                              </p>
                              <p className="card-value ft-14 fw-400">
                                {x.effectiveTo
                                  ? moment(new Date(x.effectiveTo)).format(
                                      "MM/DD/YYYY"
                                    )
                                  : "-"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </LoaderWrapper>
    </ManagePlanLayout>
  );
};

export default Eligibility;
